import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=a53323ca&scoped=true&lang=pug"
import script from "./ModalWindow.vue?vue&type=script&lang=ts"
export * from "./ModalWindow.vue?vue&type=script&lang=ts"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=a53323ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53323ca",
  null
  
)

export default component.exports